import React, { Component } from 'react';
// components
import AudioPlayer from '../../../components/AudioPlayer/AudioPlayer';
import SkillsPlaceholder from '../../Skills/components/SkillsPlaceholder';
import Icon from '../../../components/Icon/Icon';
import StepTitle from './StepTitle';
// utils
import T from 'prop-types';
// styles
import styles from './LectureStep.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class LectureStep extends Component {
  state = {
    conditionMessage: null
  };

  componentDidMount() {
    const {
      getLectureCondition,
      data: {
        content: { id, conditions }
      }
    } = this.props;

    conditions &&
      getLectureCondition({ id }).then(({ value }) =>
        this.setState({
          conditionMessage: value[0].message
        })
      );
  }

  closeConditionMessage = () => {
    this.setState({ conditionMessage: null });
  };

  render() {
    const { conditionMessage } = this.state;
    const {
      data: {
        description,
        content: { title, content, sound_link, post_component }
      }
    } = this.props;

    return (
      <div className={cx('wrapper')}>
        {conditionMessage && (
          <span className={cx('conditionMessage', 'fadeIn')}>
            {conditionMessage}
            <Icon
              type="close"
              className={cx('closeIcon')}
              onClick={this.closeConditionMessage}
            />
          </span>
        )}
        <StepTitle title={title} description={description} />
        {sound_link && <AudioPlayer title={title} src={sound_link} />}
        <div
          className={cx('lecture')}
          dangerouslySetInnerHTML={{ __html: content }}
        />
        {post_component === 'skills' && <SkillsPlaceholder />}
      </div>
    );
  }
}

LectureStep.propTypes = {
  data: T.shape({
    content: T.shape({
      title: T.string.isRequired,
      content: T.string.isRequired
    })
  })
};

export default LectureStep;



// WEBPACK FOOTER //
// ./src/containers/Module/components/LectureStep.jsx